"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoxApi = void 0;
const Api_1 = require("./Api");
const PaymentMethods_1 = require("../helpers/PaymentMethods");
class FoxApi {
    constructor(config) {
        this.api = (0, Api_1.Api)(config);
    }
    handleError(err) {
        return Promise.reject(err);
    }
    getPaymentMethods() {
        return this.api
            .get("/getPaymentMethods", { authenticate: true })
            .then((res) => res.data)
            .then((res) => (0, PaymentMethods_1.parsePaymentMethods)(res))
            .catch(this.handleError);
    }
    changeService(service) {
        const params = {
            changeType: (service === null || service === void 0 ? void 0 : service.isDowngrade) ? "Downgrade" : "Upgrade",
            couponCode: service === null || service === void 0 ? void 0 : service.couponCode,
            promotionId: service === null || service === void 0 ? void 0 : service.promotionId,
            newServiceID: service.planId,
            paymentmethodInfo: service.paymentmethodInfo,
            parameters: [
                {
                    paramName: "Operation Type",
                    paramValue: (service === null || service === void 0 ? void 0 : service.isDowngrade) ? "Downgrade" : "Upgrade",
                },
            ],
            shippingAddress: service === null || service === void 0 ? void 0 : service.shippingAddress,
        };
        return this.api
            .post("/changeSubscription", params, { authenticate: true })
            .then((res) => res.data)
            .catch(this.handleError);
    }
    applyCoupon(couponCode) {
        return this.api
            .post("/applyCouponV2", {
            couponCode,
        }, { authenticate: true })
            .then((res) => res.data)
            .catch(this.handleError);
    }
}
exports.FoxApi = FoxApi;
//# sourceMappingURL=FoxApi.js.map